import { Box, BoxProps, styled } from '@mui/material';
import { PlaceholderIcon } from '@synergy/theme-next';
import { ReactElement, useState } from 'react';

interface PoolImageProps extends BoxProps {
    src: string | undefined;
    alt: string | undefined;
}

const ImagePlaceholder = styled(PlaceholderIcon)(() => ({
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    style: {
        maxWidth: '255px',
    },
}));

export const PoolImage = (props: PoolImageProps): ReactElement => {
    const [error, setError] = useState(false);

    if (error || !props.src) return <ImagePlaceholder style={props.style} sx={props.sx} className={props.className} />;

    return <Box component="img" onError={() => setError(true)} {...props} />;
};
